
export const front = {
	el: '#main-vue',
	mixins: [],

	ready() {
		console.log('corre front')
		
	},
};
